import {
  createStore,
  combineReducers,
  applyMiddleware,
  compose,
} from "redux";
import { thunk } from "redux-thunk";

import {
  userReducers,
  userEditReducers,
  userDeleteOrDeactivateAccountReducer,
  userForgotPasswordReducer,
  // admin
  allUsersAdminReducer,
  userDetailsAdminReducer,
  userUpDeAdminReducer,
} from "./reducers/userReducers";
import {
  newListingReducer,
  updateListingReducer,
  listingsReducer,
  listingDetailsReducer,
  listingUpDeReducer,
  deleteListingUserReducer,
  // user listings reducers
  userListingsReducer,
  userGetLikedListingsReducer,
  // public listings reducers
  allListingsPublicReducer,
  increaseListingViewCountReducer,
} from "./reducers/listingReducers";
import { contactReducer } from "./reducers/contactReducers";

const reducer = combineReducers({
  user: userReducers,
  userEdit: userEditReducers,
  userDeleteOrDeactivateAccount: userDeleteOrDeactivateAccountReducer,
  forgotPassword: userForgotPasswordReducer,
  // User listing CRUD
  userListings: userListingsReducer,
  userGetLikedListings: userGetLikedListingsReducer,
  newListing: newListingReducer,
  updateListing: updateListingReducer,
  listings: listingsReducer,
  listingDetails: listingDetailsReducer,
  listingUpDe: listingUpDeReducer,
  deleteListingUser: deleteListingUserReducer,
  contact: contactReducer,
  // user reducers for admin
  allUsersAdmin: allUsersAdminReducer,
  userDetailsAdmin: userDetailsAdminReducer,
  userUpDeAdmin: userUpDeAdminReducer,
  // public listings reducers
  allListingsPublic: allListingsPublicReducer,
  increaseListingViewCount: increaseListingViewCountReducer,
});

// If we have a saved userId, the user is likely still authenticated (the
// httpOnly refresh-token cookie will confirm in App.js's loadUser() call).
// Pre-seed the user slice with loading: true so route guards
// (UserRoute / AdminRoute) wait for the auth check to resolve instead of
// flashing a redirect to /users/login on the first paint after refresh.
const hasSavedUserId =
  typeof window !== "undefined" &&
  window.localStorage.getItem("userId") !== null;

const initialState = {
  user: hasSavedUserId ? { user: {}, loading: true } : { user: {} },
  newListing: {
    propertyAddress: localStorage.getItem("propertyAddress")
      ? JSON.parse(localStorage.getItem("propertyAddress"))
      : {
          mapPosition: { lat: "", lng: "" },
          markerPosition: { lat: "", lng: "" },
          toPropertyDetails: false,
          toPropertySubmit: false,
        },
    propertyDetails: localStorage.getItem("propertyDetails")
      ? JSON.parse(localStorage.getItem("propertyDetails"))
      : {},
  },
  updateListing: {
    updatedPropertyAddress: localStorage.getItem("updatedPropertyAddress")
      ? JSON.parse(localStorage.getItem("updatedPropertyAddress"))
      : {},
    updatedPropertyDetails: localStorage.getItem("updatedPropertyDetails")
      ? JSON.parse(localStorage.getItem("updatedPropertyDetails"))
      : {},
  },
};

// Use the Redux DevTools browser-extension hook directly — no redux-devtools-extension
// package needed (it was deprecated in favour of the extension's own compose helper).
const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const store = createStore(
  reducer,
  initialState,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
